import { normalizeCommerceLink } from "utils/links";
import { CUSTOMER_CARE_LANDING_PAGE, CUSTOMER_CARE_TRANSACT_GUEST } from "../constants/header-account-features";
import { getRelativeURLWithParams } from "utils/url";
import { CSR_LEGACY_LANDING_PAGE_ROUTE } from "constants/links";
import { useEsiteCtx } from "services/esite/context";
import { useNavigationDrawers } from "../components/navigation-drawers-context";
import { useDealerLocatorModal } from "components/dealer-locator/dealer-locator-modal-context";

export const useCSRFeatures = (isCatCsrUser: boolean) => {
  const { catalogId, langId, storeId } = useEsiteCtx();
  const navigationDrawers = useNavigationDrawers();
  const dealerLocatorModal = useDealerLocatorModal();

  if (isCatCsrUser) {
    const customerCareFeature = {
      label: CUSTOMER_CARE_LANDING_PAGE.label,
      helperText: CUSTOMER_CARE_LANDING_PAGE.helperText,
      link: normalizeCommerceLink(
        getRelativeURLWithParams(CSR_LEGACY_LANDING_PAGE_ROUTE, {
          storeId,
          langId,
          catalogId
        })
      )
    };
    const transactGuestFeature = {
      label: CUSTOMER_CARE_TRANSACT_GUEST.label,
      helperText: CUSTOMER_CARE_TRANSACT_GUEST.helperText,
      // Show dealer locator to handle the transaction as guest.
      onClick: () => {
        navigationDrawers?.accountDrawer?.closeDrawer();
        dealerLocatorModal?.modalControl?.open();
      }
    };
    return [customerCareFeature, transactGuestFeature];
  }
}